import React, { useState, useEffect } from 'react';
import ImageUpload from './imageUpload';
import { Box, Button, Dialog, DialogTitle, DialogActions, DialogContent, Typography, TextField, Switch, FormControlLabel } from '@mui/material';
import { getStoreDetails, updateStoreDetails } from '../services/user'
import { useSnackbar } from '../context/snackbarContext.js';
import { setStore, getStore } from "../util";

const UpdateProfile = ({open, handleClose, }) => {
        const [address1, setAddress1] = useState("")
        const [address2, setAddress2] = useState("")
        const [city, setCity] = useState("")
        const [zip, setZip] = useState("")
        const [phone, setPhone] = useState("")
        const [email, setEmail] = useState("")
        const [website, setWebsite] = useState("")
        const [logUrl, setLogoUrl] = useState("")
        const [logPhoto, setLogoPhoto] = useState("")
        const [downloadBooking, setDownloadBooking] = useState(false)
        const [cropOpen, setCropOpen] = useState("")
        const [data, setData] = useState()

        const { showSnackbar } = useSnackbar();
        
        const getData = async () => {
            try {
                const _data = await getStoreDetails()
                setData(_data)
                setAddress1(_data?.address?.addressLine1 ?? "")
                setAddress2(_data?.address?.addressLine2 ?? "")
                setCity(_data?.address?.city ?? "")
                setZip(_data?.address?.zip ?? "")
                setPhone(_data?.contactNumber ?? "")
                setEmail(_data?.email ?? "")
                setWebsite(_data?.website ?? "")
                setLogoUrl(`${_data?.logo}?time=${Date.now()}` ?? "")
                setDownloadBooking(_data?.downloadBooking)
            } catch (e) {
                console.log(e)
            }
        }

        useEffect(()=>{
            getData()
        }, [])

        const handleSave = async() => {
            let updObj = {}
            
            if (data?.address?.addressLine1 !== address1.trim()) {
                updObj.addressLine1 = address1.trim()
            }
            if (data?.address?.addressLine2 !== address2.trim()) {
                updObj.addressLine2 = address2.trim()
            }
            if (data?.address?.city !== city.trim()) {
                updObj.city = city.trim()
            }
            if (data?.address?.zip !== zip.trim()) {
                updObj.zip = zip.trim()
            }
            if (data?.contactNumber !== phone.trim()) {
                updObj.contactNumber = phone.trim()
            }
            if (data?.email !== email.trim()) {
                updObj.email = email.trim()
            }
            if (data?.website !== website.trim()) {
                updObj.website = website.trim()
            }
            console.log(data.downloadBooking, downloadBooking)
            if (data?.downloadBooking !== downloadBooking) {
                updObj.downloadBooking = downloadBooking
            }
            
            const fd = new FormData();
            fd.append('data', JSON.stringify(updObj))
            if (logPhoto) {
                fd.append('logo', logPhoto)
            }
            try {
                await updateStoreDetails(fd)
                showSnackbar("Updated Profile", "success")
                if (updObj.downloadBooking !== undefined) {                    
                    const user = getStore('user');
                    user.user.downloadBooking = updObj.downloadBooking
                    setStore('user', user);
                    window.dispatchEvent(new Event("PROFILE_UPDATE"));
                }
                handleClose()
            } catch (e) {
                showSnackbar("Could not update profile", "error")
            }
        }

        return (
            <Dialog onClose={handleClose} fullWidth={true} disableEscapeKeyDown={cropOpen ? true : false}
            maxWidth={"md"} aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose} sx={{display:'flex', alignItems:'center'}}>
                    <Typography> Edit Profile  </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{display: 'flex', flexDirection: 'row'}}>
                    <Box sx={{display: 'flex', flexDirection: 'column', width:'48%', pr:2, pl: 2}}>
                        <TextField sx={{mb:1}} value={address1} onChange={(e)=>{setAddress1(e.target.value)}} label="Address Line 1"/>
                        <TextField sx={{mb:1}} value={address2} onChange={(e)=>{setAddress2(e.target.value)}} label="Address Line 2"/>
                        <TextField sx={{mb:1}} value={city} onChange={(e)=>{setCity(e.target.value)}} label="City"/>
                        <TextField sx={{mb:1}} value={zip} onChange={(e)=>{setZip(e.target.value)}} label="Zip Code"/>
                        <TextField sx={{mb:1}} value={phone} onChange={(e)=>{setPhone(e.target.value)}} label="Phone"/>
                        <TextField sx={{mb:1}} value={email} onChange={(e)=>{setEmail(e.target.value)}} label="Email"/>
                        <TextField sx={{mb:1}} value={website} onChange={(e)=>{setWebsite(e.target.value)}} label="Website"/>
                        <Box sx={{ p: 3 }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={downloadBooking}
                                    onChange={(e)=>{setDownloadBooking(e.target.checked)}}
                                />
                            }
                            label={"Download Booking"}
                            />
                        </Box>
                    </Box>
                    <Box sx={{width: '48%', display:"flex", alignItems: 'center', justifyContent: 'center'}}>
                        <ImageUpload
                            avatarUrl={logUrl}
                            label="Logo"
                            setFile={setLogoPhoto}
                            setAvatarUrl={setLogoUrl}
                            isSquare={true}
                            element="logo"
                            type="document"
                            setCropOpen={setCropOpen}
                            format="png"
                            aspectRatio={1}
                            minCropBoxWidth={512}
                            minCropBoxHeight={512}
                            cropBoxResizable={false}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant='outlined'>Cancel</Button>
                    <Button onClick={handleSave} variant='contained'>Save</Button>
                </DialogActions>
            </Dialog>
        )
    
}

export default UpdateProfile;

